import React from 'react'
import PropTypes from 'prop-types'
import { Empty, Modal } from 'antd'
import _ from 'lodash'
// import HistoryList from '../../../../modules/auditManager/HistoryList'
import { generateCroppedThumbnail } from '../../../../util/util'
import TextAreaInputApp from '../inputs/TextAreaApp'
import RichText from './RichText'
// import { utilityService } from '../../../../services/UtilityService'
import './../../ui.style.scss'
import CustomMetaFileTypeIcon from './CustomMetaFileTypeIcon'
// import FilePreview from 'modules/contentManager/FilePreview'

class DisplayValueModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { isVisible, handleCancel, viewData, title } = this.props
    // const { value, data } = viewData
    let currentImage = null
    if (viewData?.data?.type === 'image') {
      const url = currentImage = !_.isEmpty(viewData?.value)
        ? generateCroppedThumbnail(viewData?.value, 180, 180, '1:1')
        : undefined
      currentImage = (
        <div className='default-image'>
          <img size={64} className='user' src={url} />
        </div>
      )
    }

    const fileName = viewData?.data?.file?.fileName || null
    let currentFile = null
    if (fileName) {
      // const extension = findFileExtension(fileName, false)
      currentFile = (
        // <FilePreview
        //   type={extension}
        //   url={fileName}
        // />
        <CustomMetaFileTypeIcon
          fileName={fileName}
          onClear={null}
          meta={null}
          fileNameToolTipPlacement='right'
        />
      )
    }

    let textArea = null
    if (viewData && viewData.data && (viewData.data.type === 'json')) {
      textArea = (
        <div className='default-richtext'>
          <TextAreaInputApp
            key={viewData.data.id}
            // title={config.name}
            inputName='title'
            value={viewData ? viewData.value : ''}
            // isRequired={config.isRequired}
            // isError={selectedMeta ? selectedMeta.isError : false}
            isEditable={false}
            // handleChange={({ target }) => handleObjectDetailsChange(config, target.value)}
            showContentInModal={false}
          />
        </div>
      )
    }

    let richText = null
    if (viewData && viewData.data && (viewData.data.type === 'richtext')) {
      richText = (
        <div className='default-richtext'>
          <RichText key={viewData.data.id} id={viewData.data.id} text={viewData ? viewData.value : ''} showCloseIcon={false} readOnly showToolbar={false} />
        </div>
      )
    }

    let fileInput = null
    if (viewData?.data?.type === 'file' && viewData?.value) {
      fileInput = (
        <div className='default-details-wrapper'>
          <CustomMetaFileTypeIcon
            fileName={viewData?.value}
            onClear={null}
            meta={null}
            fileNameToolTipPlacement='right'
          />
        </div>
      )
    }

    let defaultIcon = null
    if (!currentImage && !textArea && !richText && !fileInput && !currentFile) {
      defaultIcon = <Empty />
    }

    return (

      <Modal
        className='general-modal app-display-value-modal'
        visible={isVisible}
        title={title}
        maskClosable={false}
        closable
        onCancel={handleCancel}
        // afterClose={this.resetState}
        centered
        destroyOnClose
      >
        <div>
          {currentImage}
          {textArea}
          {richText}
          {fileInput}
          {currentFile}
          {defaultIcon}
        </div>
      </Modal>

    )
  }
}

DisplayValueModal.propTypes = {
  /** visible action of AddBucketGroupModal. */
  visible: PropTypes.bool,
  /** title  of AddBucketGroupModal. */
  title: PropTypes.string,
  /** handleCancel action of AddBucketGroupModal. */
  handleCancel: PropTypes.func,
  /** Boolean for showing loading */
  loading: PropTypes.bool,
  /** Boolean to know source of the modal */
  isFromEdit: PropTypes.bool
}

DisplayValueModal.defaultProps = {
}

export default DisplayValueModal
